export const Link = process.env.NODE_ENV === "production" ? "https://www.reelpay.com" : "https://reelpay.puttest.com/"
export const ENV = process.env.NODE_ENV === "development"

export const getRequiredNamespaces = (chain: string, chain_id: number): any => {
    switch (chain) {
        case "PUT":
            return {
                put: {
                    chains: ["put:"],
                    methods: ["put_signAndSendTransaction"],
                    events: []
                }
            }
        case "Tron":
            return {
                put: {
                    chains: ["tron:"],
                    methods: ["tron_signAndSendTransaction"],
                    events: []
                }
            }
        default:
            return {
                eip155: {
                    methods: [
                        "eth_sendTransaction",
                        "eth_signTransaction",
                        "eth_sign",
                        "personal_sign",
                        "eth_signTypedData"
                    ],
                    chains: ["eip155:" + chain_id],
                    events: ["chainChanged"]
                }
            }
    }
}
